import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getQuotation
} from 'services/redux/sales/projectOnboarding/action';
import ViewQuotation from './viewQuotation';

const mapStateToProps = (state) => ({
  quotation: state.projectOnboardingReducer.quotation
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getQuotation
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewQuotation);
